module.exports = __webpack_public_path__ + "img/arrow-right.b845be41.svg";